import mitt from 'mitt'

export default defineNuxtPlugin((_nuxt) => {
  const eventBus = mitt<EventBusEventType>()

  return {
    provide: {
      eventBus,
    },
  }
})
